import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { scrollMargin, ProductSections, stickyBarElementId } from '../common/section_config';

const useStyles = createUseStyles((theme) => ({
    item: {
        scrollMarginTop: ({ stickyBarHeight }) => stickyBarHeight
    }
}));

const ProductContent = ({ quote, pristineValue }) => {
    const [stickyBarHeight, setStickyBarHeight] = React.useState('20rem');
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, stickyBarHeight });

    React.useEffect(() => {
        const stickyBar = document.getElementById(stickyBarElementId);
        if (stickyBar) {
            setStickyBarHeight(`${stickyBar.offsetHeight + scrollMargin}px`);
        }
    }, []);

    return (
        <div className={classNames('test-policyProduct-contentSections')}>
            {
                Object.values(ProductSections).map((section) => {
                    const { id, label, component, availableOn } = section;
                    if (availableOn.includes(pristineValue)) {
                        return component({
                            key: id,
                            quote,
                            className: classes.item,
                            config: { id, label }
                        });
                    }
                    return '';
                })
            }
        </div>
    );
};

ProductContent.propTypes = {
    quote: PropTypes.object.isRequired,
    pristineValue: PropTypes.string.isRequired
};

export { ProductContent };
